module.exports = __webpack_public_path__ + "static/media/1n.d40bec88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/1n.svg
// module id = 154
// module chunks = 0